import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/services/auth-guard.service';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    },
    {
        path: 'dms',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./dms/dms.module').then(m => m.DmsModule),
    },
    {
        path: 'printPreview',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./print-preview/print-preview.module').then(m => m.PrintPreviewModule)
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
            {
                useHash: true,
                onSameUrlNavigation: 'reload',
                enableTracing: false
            }
        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
